export enum TypeEnum {
    'none',
    'success',
    'danger',
}